var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-content-wrapper" }, [
    _c(
      "div",
      { staticClass: "go-container" },
      [
        _c("div", { staticClass: "go-page-header-type2" }, [
          _c("div", { staticClass: "go-page-title" }, [
            _vm._v(_vm._s(_vm.$t("my-create.common.navbar.podcast"))),
          ]),
        ]),
        _vm._v(" "),
        _vm.initialLoading
          ? _c("list-loading")
          : [
              _vm.checkPodcastData
                ? _c(
                    "div",
                    { staticClass: "go-section go-section-contents creates" },
                    [
                      _c("div", { staticClass: "go-section-header" }, [
                        _c("div", { staticClass: "go-search-results-sort" }, [
                          _c(
                            "div",
                            { staticClass: "go-search-results-sort-tab" },
                            [
                              _c("ul", { staticClass: "nav go-tab-pills" }, [
                                _c("li", { staticClass: "go-tab-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "go-tab-link",
                                      class: {
                                        active:
                                          _vm.selectedTab === "All" &&
                                          !_vm.mediaType,
                                      },
                                      attrs: {
                                        "data-toggle": "tab",
                                        "data-target": "#go-report-all",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.selectTab("All")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my-create.podcast.all")
                                        ) +
                                          " (" +
                                          _vm._s(_vm.totalElementPodcast) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "go-tab-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "go-tab-link",
                                      class: {
                                        active: _vm.mediaType === "DAILY",
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.selectTab("Daily Goover")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t("my-create.podcast.daily")
                                          ) +
                                          " Goover (" +
                                          _vm._s(_vm.dailyGooverCount) +
                                          ")\n                  "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "go-tab-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "go-tab-link",
                                      class: {
                                        active: _vm.mediaType === "WEEKLY",
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.selectTab("Weekly Goover")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t("my-create.podcast.weekly")
                                          ) +
                                          " Goover (" +
                                          _vm._s(_vm.weeklyGooverCount) +
                                          ")\n                  "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "go-elements" }, [
                                _c("div", { staticClass: "go-filter-item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-dropdown",
                                      attrs: { type: "button" },
                                      on: { click: _vm.toggleDropdown },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.dropdownButtonText) +
                                          "\n                    "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "go-icon-18 go-icon-chevron-down",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      class: { show: _vm.isDropdownOpen },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "go-period-option" },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "go-option-list" },
                                            _vm._l(
                                              _vm.periods,
                                              function (period) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: period.key,
                                                    staticClass: "go-list-item",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "go-list-link",
                                                        class: {
                                                          active:
                                                            _vm.selectedPeriod ===
                                                            period.key,
                                                        },
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.selectPeriod(
                                                              period.key
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              period.value
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "go-input-group" },
                                            [
                                              _c("date-picker", {
                                                ref: "datePickerRef",
                                                style: { width: "100%" },
                                                attrs: {
                                                  disabled:
                                                    _vm.selectedPeriod !==
                                                    "Choose period",
                                                  range: "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "content",
                                                      fn: function () {
                                                        return [
                                                          _c("calendar-panel", {
                                                            attrs: {
                                                              value:
                                                                _vm.innerValue,
                                                              "disabled-date":
                                                                _vm.disableFutureDates,
                                                              "get-classes":
                                                                _vm.getClasses,
                                                            },
                                                            on: {
                                                              select:
                                                                _vm.handleSelect,
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  170238217
                                                ),
                                                model: {
                                                  value: _vm.dateRangeValue,
                                                  callback: function ($$v) {
                                                    _vm.dateRangeValue = $$v
                                                  },
                                                  expression: "dateRangeValue",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-filter-item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-dropdown",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.selectedLanguageDisplay) +
                                          "\n                    "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "go-icon-18 go-icon-chevron-down",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-item-wrap" },
                                        _vm._l(_vm.languages, function (lang) {
                                          return _c(
                                            "a",
                                            {
                                              key: lang.key,
                                              staticClass: "dropdown-item",
                                              class: {
                                                active:
                                                  _vm.selectedLanguage ===
                                                  lang.key,
                                              },
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.selectLanguage(
                                                    lang.key
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(lang.value) +
                                                  "\n                      "
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.isLoading &&
                      _vm.filteredPodcasts &&
                      _vm.filteredPodcasts.length > 0
                        ? _c(
                            "div",
                            { staticClass: "go-section-body" },
                            [
                              _c(
                                "div",
                                { staticClass: "go-card-main-grid my-creates" },
                                [
                                  _vm.loadingList.length > 0
                                    ? _vm._l(
                                        _vm.loadingList,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "go-list-item",
                                              attrs: { "data-size": "1x1" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "go-card-main" },
                                                [
                                                  _c(
                                                    "loading-report-card-component",
                                                    {
                                                      attrs: {
                                                        "form-model": item,
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filteredPodcasts,
                                    function (podcast, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "go-list-item",
                                          attrs: { "data-size": "1x1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "go-card-main" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "go-card-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-block-header",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "go-card-header",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-card-info",
                                                              class: {
                                                                "": !podcast
                                                                  .parentDocDetail
                                                                  .media_type[1],
                                                              },
                                                            },
                                                            [
                                                              podcast
                                                                .parentDocDetail
                                                                .media_type[1]
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "go-card-label",
                                                                      staticStyle:
                                                                        {
                                                                          padding:
                                                                            "3px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "em",
                                                                        {
                                                                          staticClass:
                                                                            "go-text",
                                                                          staticStyle:
                                                                            {
                                                                              padding:
                                                                                "5px !important",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                            " +
                                                                              _vm._s(
                                                                                _vm.convertRecapType(
                                                                                  podcast
                                                                                    .parentDocDetail
                                                                                    .media_type[1]
                                                                                )
                                                                              ) +
                                                                              "\n                            Goover"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "go-card-title",
                                                                  class: podcast
                                                                    .parentDocDetail
                                                                    .media_type[1]
                                                                    ? "clamp-3"
                                                                    : "clamp-4",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showRecap(
                                                                          podcast
                                                                            .parentDocDetail
                                                                            .recap_id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        podcast
                                                                          .parentDocDetail
                                                                          .title
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "go-card-icon",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "go-icon-24 go-icon-headphones",
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-block-body",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "go-block-wrap",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-card-info",
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "go-user-thumb",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: podcast
                                                                        .parentDocDetail
                                                                        .other_info
                                                                        .host_img,
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "go-text-wrap",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "go-user-name",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.formattedSpeakers(
                                                                              podcast
                                                                                .parentDocDetail
                                                                                .other_info
                                                                                .speakers_info
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-btn-area",
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn go-btn-icon",
                                                                  class: {
                                                                    active:
                                                                      _vm.currentPlayingId ===
                                                                        podcast._id &&
                                                                      _vm.isPlaying,
                                                                  },
                                                                  attrs: {
                                                                    type: "button",
                                                                    disabled:
                                                                      !_vm.podcastEnabled,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.togglePlay(
                                                                          podcast
                                                                            .parentDocDetail
                                                                            .source_uri,
                                                                          podcast._id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "go-icon-24",
                                                                    class:
                                                                      _vm.currentPlayingId ===
                                                                        podcast._id &&
                                                                      _vm.isPlaying
                                                                        ? "go-icon-player-pause-filled"
                                                                        : "go-icon-player-play-filled",
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-block-footer",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "go-card-info",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "go-info-item go-datetime",
                                                            },
                                                            [
                                                              _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "go-text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatDateAgo(
                                                                        _vm.moment(
                                                                          podcast.published_at
                                                                        )
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "go-btn-area",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "dropdown",
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn go-btn-icon",
                                                                  attrs: {
                                                                    type: "button",
                                                                    "data-toggle":
                                                                      "dropdown",
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "go-icon-20 go-icon-more-dot",
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "dropdown-menu dropdown-menu-right",
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.bookmark(
                                                                              podcast._id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-18",
                                                                        class:
                                                                          _vm
                                                                            .bookmarkedPodcasts[
                                                                            podcast
                                                                              ._id
                                                                          ]
                                                                            ? "go-icon-bookmark-on"
                                                                            : "go-icon-bookmark-line",
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .bookmarkedPodcasts[
                                                                                podcast
                                                                                  ._id
                                                                              ]
                                                                                ? _vm.$t(
                                                                                    "my-create.podcast.unBookmark"
                                                                                  )
                                                                                : _vm.$t(
                                                                                    "my-create.podcast.bookmark"
                                                                                  )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.copyPodcastUrl(
                                                                              podcast
                                                                                .parentDocDetail
                                                                                .source_uri
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-20 go-icon-share",
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "common.label.share"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.downloadPodcast(
                                                                              podcast
                                                                                .parentDocDetail
                                                                                .source_uri,
                                                                              podcast
                                                                                .parentDocDetail
                                                                                .title
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-20 go-icon-download",
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "my-create.podcast.download"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.isLoadingMore ? _c("list-loading") : _vm._e(),
                            ],
                            1
                          )
                        : _vm.isLoading && !_vm.isLoadingMore
                        ? _c("list-loading")
                        : _c("div", { staticClass: "go-section creates" }, [
                            _c("div", { staticClass: "go-section-body" }, [
                              _c("div", { staticClass: "go-empty" }, [
                                _c("div", { staticClass: "go-icon-wrap" }, [
                                  _c("i", {
                                    staticClass:
                                      "go-icon-48 go-icon-alert-circle",
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "go-info-lead" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("my-create.podcast.nodata"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "go-info-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my-create.podcast.nodataSuggest")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-btn-area" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-default",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goHome()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "my-create.podcast.getStarted"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "go-icon-16 go-icon-chevron-right",
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                    ],
                    1
                  )
                : _c("div", { staticClass: "go-section creates" }, [
                    _c("div", { staticClass: "go-section-body" }, [
                      _c("div", { staticClass: "go-empty" }, [
                        _c("div", { staticClass: "go-icon-wrap" }, [
                          _c("i", {
                            staticClass: "go-icon-48 go-icon-alert-circle",
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "go-info-lead" }, [
                          _vm._v(_vm._s(_vm.$t("my-create.podcast.nodata"))),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "go-info-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("my-create.podcast.nodataSuggest"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-btn-area" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-default",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.goHome()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("my-create.podcast.getStarted")
                                  ) +
                                  "\n                "
                              ),
                              _c("i", {
                                staticClass: "go-icon-16 go-icon-chevron-right",
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }